var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 19.465,
    viewBox: "0 0 60 19.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(-392 -2034.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa-2",
    "data-name": "visa",
    transform: "translate(380.774 1982.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163516",
    "data-name": "Group 163516",
    transform: "translate(11.226 51.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M37.237,70.66h-4.9l3.06-18.8h4.9Zm-9.015-18.8L23.554,64.789,23,62h0l-1.647-8.457a2.1,2.1,0,0,0-2.322-1.693H11.317l-.091.318a18.315,18.315,0,0,1,5.121,2.149L20.6,70.66h5.1l7.789-18.805Zm38.509,18.8h4.5l-3.92-18.805H63.371a2.25,2.25,0,0,0-2.26,1.4l-7.3,17.4h5.1l1.021-2.793h6.224Zm-5.387-6.652,2.572-7.037,1.447,7.037Zm-7.151-7.631.7-4.038a14.131,14.131,0,0,0-4.4-.82c-2.43,0-8.2,1.062-8.2,6.225,0,4.858,6.772,4.919,6.772,7.47s-6.074,2.095-8.078.485l-.728,4.222a13.72,13.72,0,0,0,5.526,1.062c3.341,0,8.381-1.73,8.381-6.438,0-4.889-6.832-5.345-6.832-7.47s4.769-1.853,6.864-.7Z",
    transform: "translate(-11.226 -51.519)",
    fill: "#fdfdfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M23,62.336l-1.647-8.457a2.1,2.1,0,0,0-2.322-1.693H11.317l-.091.318a18.969,18.969,0,0,1,7.266,3.648A14.664,14.664,0,0,1,23,62.336Z",
    transform: "translate(0 -0.331)",
    fill: "#fdfdfd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.9b390a44a4133f75d706abf8a9c47867.svg";
export { ForwardRef as ReactComponent };